module.exports = __webpack_public_path__ + "img/shine.4e2947f6.gif";